export const PRODUTO_TIPOS_COM_DESPESA = 'MERCADORIA,PRODUTO_ACABADO,SERVICO,VEICULO,USO_CONSUMO,DESPESA';
